import { Types } from 'service-api'

export const getExternalAccountByType = (
  location: Types.LocationClientDto,
  accountType: Types.TExternalAccountTypes
) => {
  if (typeof location === 'undefined') {
    return null
  }
  const externalAccount = location.externalAccountLocations?.find((ea) => ea.externalAccount?.type === accountType)
  return externalAccount ? externalAccount.externalAccount : null
}

export const getExternalAccountReach = (location: Types.LocationClientDto) =>
  getExternalAccountByType(location, 'REACH_TENANT')?.externalReferenceId
